exports = module.exports = require("../../../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "[dir] .ConfirmationDialog_confirmationDialog__3dysb .ant-modal-footer{border-top:none !important}", ""]);

// Exports
exports.locals = {
	"confirmationDialog": "ConfirmationDialog_confirmationDialog__3dysb"
};